import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import { HisUiService, HisNotificationService } from 'hisng';

import { DocumentMetadata } from '../../model/documents/documentMetadata';
import { DocumentService } from './document.service';

@Injectable()
export class DocumentHelperService {

    constructor( private hisUiService: HisUiService,
        private notificationService: HisNotificationService,
        private documentService: DocumentService ) {
    }

    /* get untrusted domain download URL for documentMetadata
     * @param documentMetadata using documentMetadata to get URL from map
     */
    public downloadDocument( documentMetadata: DocumentMetadata ) {
        // generate and add untrusted domain URLs to map
        this.documentService.getDocDownloadURL( documentMetadata ).subscribe( (docDownloadURL: string) => {
            // trigger download file via window.location
            window.location.href = docDownloadURL;
        } );
    }

    /**
     * common helper method to detect and save changes on documentMetadata for object
     *
     * @param documentsToSave original DocumentMetadata array to save
     */
    public detectChangesAndSaveDocumentMetadata( documentsToSave: DocumentMetadata[] ): Observable<boolean> {
        // to get the info when service call is finished to trigger reload of documentsToSave on component side
        let $serviceComplete = new BehaviorSubject( null );

        // check if documentsToSave are empty
        if ( documentsToSave && !!documentsToSave.length ) {
            // create working copy of documentMetadata array, cause original one will be reseted after save/update to trigger reload
            let documentsWorkingCopy = documentsToSave;

            let anyFilesNull = false;
            // check if all documents in list contain a file
            documentsWorkingCopy.forEach( d => {
                // if one of the attributes is null, file wasn't uploaded before
                if ( !d.fileName || !d.mimedata.createdAt ) {
                    anyFilesNull = true;
                }
            } );

            // if documentMetadata list contains objects where no file connected file
            if ( anyFilesNull ) {
                this.notificationService.errorI18n( 'fs.res.common.documents.save.noFileSelected' );
                $serviceComplete.next( false );
            } else {

                // is at least one document without category, filter to trigger validation only once
                let docsWithoutCategory = documentsWorkingCopy.filter( doc => doc.category == null );
                if ( !!docsWithoutCategory.length ) {
                    documentsWorkingCopy = new Array<DocumentMetadata>( docsWithoutCategory[0] );
                }

                // service to save changes on documentMetadata
                documentsWorkingCopy.forEach( d => {
                    // if createdAt was set to null, documentMetadata is to delete
                    if ( d.markForDelete ) {
                        console.log( 'For documentMetadata with ObjGuid ' + d.objGuid
                            + ' was marked for delete call documentService.deleteDocumentMetadata' );
                        // call documentService deleteDocumentMetadata()
                        this.documentService.deleteDocumentMetadata( d ).subscribe( (deleteSuccess: number) => {
                            // when complete reinitialized array of documentsToSave on component to trigger reload
                            $serviceComplete.next( true );
                        } );
                    } else {
                        console.log( 'For documentMetadata with ObjGuid ' + d.objGuid
                            + ' was marked for delete call documentService.deleteDocumentMetadata' );
                        // call documentService saveDocumentMetadata()
                        this.documentService.saveDocumentMetadata( d ).subscribe(
                            ( documentMetadata: DocumentMetadata ) => {
                                if ( documentMetadata.id ) {
                                    // when complete reinitialized array of documentsToSave on component to trigger reload
                                    $serviceComplete.next( true );
                                }
                            } );
                    }
                } );
            }
        } else {
            console.log( 'DocumentHelperService.detectChangesAndSaveDocumentMetadata - documentsToSave null or empty: ', documentsToSave );
            // just to return save success for reference object
            $serviceComplete.next( true );
        }
        return $serviceComplete;
    }

}
